module.exports = __webpack_public_path__ + "img/upper_pockets_move_vertically.fea60813.png";